export type PaginationSegment = number | 'ellipsis'

/** Mirrors change-log footer truncation: first, last, current ±1, ellipsis gaps; all pages when ≤7. */
export const buildVisiblePages = (pageCount: number, page: number): PaginationSegment[] => {
  if (pageCount <= 0) return []
  if (pageCount <= 7) {
    return Array.from({ length: pageCount }, (_, index) => index + 1)
  }

  const pages: PaginationSegment[] = [1]
  const rangeStart = Math.max(2, page - 1)
  const rangeEnd = Math.min(pageCount - 1, page + 1)

  if (rangeStart > 2) {
    pages.push('ellipsis')
  }

  for (let pageNumber = rangeStart; pageNumber <= rangeEnd; pageNumber += 1) {
    pages.push(pageNumber)
  }

  if (rangeEnd < pageCount - 1) {
    pages.push('ellipsis')
  }

  pages.push(pageCount)
  return pages
}

export const entryRangeBounds = (
  page: number,
  pageSize: number,
  totalCount: number
): { from: number; to: number } => {
  if (totalCount <= 0) {
    return { from: 0, to: 0 }
  }

  const from = (page - 1) * pageSize + 1
  const to = Math.min(page * pageSize, totalCount)
  return { from, to }
}
